import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import ReactAutocomplete from "ron-react-autocomplete";
import {ExcelColumn} from "react-data-grid";

export default class AutoCompleteEditor extends React.Component {
  constructor(props) {
    super(props);

    this.search = this.search.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  getValue() {
    let updated = {};
    if (this.autoComplete.state.focusedValue && this.autoComplete.state.focusedValue.value) {
      updated[this.props.column.key] = this.autoComplete.state.focusedValue.value;
    }
    return updated;
  }

  getEditorDisplayValue() {
    let displayValue = {title: ''};
    let {column, value, editorDisplayValue} = this.props;
    if (editorDisplayValue && typeof editorDisplayValue === 'function') {
      displayValue.title = editorDisplayValue(column, value);
    } else {
      displayValue.title = value;
    }
    return displayValue;
  }

  getInputNode() {
    return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0];
  }

  getLabel(item) {
    let label = this.props.label !== null ? this.props.label : 'title';
    if (typeof label === 'function') {
      return label(item);
    } else if (typeof label === 'string') {
      return item[label];
    }
  }

  hasResults() {
    return this.autoComplete.state.results.length > 0;
  }

  isFocusedOnSuggestion() {
    let autoComplete = this.autoComplete;
    return autoComplete.state.focusedValue !== null;
  }

  constructValueFromParams(obj, props) {
    if (!props) {
      return '';
    }

    let ret = [];
    for (let i = 0, ii = props.length; i < ii; i++) {
      ret.push(obj[props[i]]);
    }
    return ret.join('|');
  }

  search(options, searchTerm, callback) {
    if (this.props.search) {
      this.props.search(this.props.rowData, options, searchTerm, callback);
    } else {
      callback(null, []);
    }
  }

  onChange(event) {
    if (this.props.onCommit) this.props.onCommit(event);
  }

  render() {
    let label = this.props.label !== null ? this.props.label : 'title';
    return (<div height={this.props.height} onKeyDown={this.props.onKeyDown}>
      <ReactAutocomplete
        ref={(node) => this.autoComplete = node}
        label={label}
        search={this.search}
        onChange={this.onChange}
        onFocus={this.props.onFocus}
        resultIdentifier={this.props.resultIdentifier}
        options={this.props.options}
        value={this.getEditorDisplayValue()}/>
    </div>);
  }
}

AutoCompleteEditor.propTypes = {
  onCommit: PropTypes.func,
  getOptions: PropTypes.func,
  rowData: PropTypes.any,
  label: PropTypes.any,
  value: PropTypes.any,
  height: PropTypes.number,
  valueParams: PropTypes.arrayOf(PropTypes.string),
  column: PropTypes.shape(ExcelColumn),
  resultIdentifier: PropTypes.string,
  search: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  editorDisplayValue: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./src/views/admin/AutoCompleteEditor.js
 **/